import { MetricTypes, SurvivalHorizonData, AccountFlow, ThroughputData } from '@liquitics/transaction';
import { TrendMetric } from './../trend-metric/trend-metric';
export class ThroughputMetric extends TrendMetric {
    throughput: ThroughputData;
    actualPayPercentage: number;
    actualRecPercentage: number;
    constructor() {
        super(MetricTypes.THROUGHPUT, 'throughput');
    }

}
